/**
 * Given an object, an array of fields, and a search string, determines
 * whether the search string is found in the object properties by comparing
 * the lowercase version of the search string and the lowercase version of the
 * property value for a partial match.
 * @param {string} search - The search string to look for.
 * @param {object} target - The object to look in.
 * @param {array} fields - A list of properties to look in.
 * @returns {boolean} - True if found, false if not.
 */
const foundInFields = (search, target, fields) => {
  const lookupValue = search.toLowerCase();

  /**
   * A helper function for checking field values, since we have to do this
   * a whole bunch down below.
   * @param {*} field - Ideally a string, but gracefully fails if not.
   * @returns {boolean} True if the field matches, false if it does not.
   */
  const fieldMatches = (field) => 'string' === typeof field
    && - 1 < field.toLowerCase().indexOf(lookupValue);

  // Loop over specified fields to check each.
  for (let i = 0; i < fields.length; i += 1) {
    const field = target[fields[i]];
    if (field) {
      if (Array.isArray(field)) {
        for (let x = 0; x < field.length; x += 1) {
          if (fieldMatches(field[x])
            || fieldMatches(field[x].name)
            || fieldMatches(field[x].post_title)
          ) {
            return true;
          }
        }
      } else if (fieldMatches(field)) {
        return true;
      }
    }
  }
  return false;
};

export default foundInFields;
